import { Link } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import React from 'react'
import { useHistory } from 'react-router-dom';

const Forbidden = () => {
    const history = useHistory()
    return (
        <div>
            <Alert severity="warning">
                <AlertTitle>Error 403</AlertTitle>
                No cuenta con los permisos suficientes
                <br/>
                <Link component="button" variant="body2" onClick={() => { history.push('/') }}>
                    Volver al inicio
                </Link>
            </Alert>
        </div>
    )
}

export default Forbidden